import type { QueryActionCreatorResult, QueryDefinition } from '@reduxjs/toolkit/query';

interface InlineTaskInputProps {
  visible: boolean;
  onClose: () => void;
  onSuccess: () => QueryActionCreatorResult<QueryDefinition<any, any, any, any>> | void;
}

/**
 * InlineTaskInput — inline input for creating new tasks.
 */
export function InlineTaskInput({ visible, onClose }: InlineTaskInputProps) {
  if (!visible) return null;

  return (
    <div className="flex items-center gap-2 border-t p-2">
      <input
        type="text"
        autoFocus
        placeholder="New task title..."
        onKeyDown={(e) => {
          if (e.key === 'Escape') onClose();
        }}
        className="flex-1 border-none bg-transparent text-sm outline-none placeholder:text-gray-400"
      />
      <button
        onClick={onClose}
        className="rounded bg-gray-100 px-3 py-1 text-xs text-gray-600 hover:bg-gray-200"
      >
        Cancel
      </button>
    </div>
  );
}

export default InlineTaskInput;
